import { useParams } from 'react-router-dom';
import { api } from '../lib/api';
import { useAsync } from '../lib/useAsync';

export function Fans() {
  const { orgId } = useParams();
  const org = useAsync(() => api.orgs.get(orgId!), [orgId]);
  const fans = useAsync(() => api.fans.list(orgId!), [orgId]);
  const hasPii = fans.data?.some((f) => f.email) ?? false;
  return (
    <>
      <h1>{org.data?.name ?? '…'} <span className="muted" style={{ fontWeight: 400 }}>· Fans</span></h1>
      {fans.error && <p className="err">{fans.error}</p>}
      {fans.data && !hasPii && fans.data.length > 0 && <p className="muted">Emails are shown to org owners only (pii:read).</p>}
      {fans.data && fans.data.length === 0 && <div className="empty">No fans yet.</div>}
      {fans.data && fans.data.length > 0 && (
        <table>
          <thead><tr><th>Fan</th><th>Points</th><th>Tier</th><th>Joined</th></tr></thead>
          <tbody>
            {fans.data.map((f) => (
              <tr key={f.personId}>
                <td>{f.email ?? <code>{f.personId.slice(0, 8)}</code>}</td>
                <td>{f.points.toLocaleString()}</td>
                <td>{f.tier ?? <span className="muted">—</span>}</td>
                <td className="muted">{new Date(f.joinedAt).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}
